import React, { useState, useEffect } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TableFooter } from '@mui/material';
import isGHMC from '../../../Common/helper/helpar';
import { getLiveInnerReports, getLiveReports } from '../../../Apis/TrafficMarshalReports/ReportsTrafficMarshal';
import { useNavigate } from "react-router-dom";
import Loader from '../../../Common/Loader/loader';
import ExcelJS from "exceljs";
import TableSkeleton from '../../AllotedMaster/TableSkeleton';

const LiveReports = () => {
  const [rows, setRows] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const isProd = isGHMC();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setDataLoading(true);
      try {
        const response = await getLiveReports();
        const responseData = response.data;
        const formattedData = responseData.map((item, index) => {
          return {
            sNo: index + 1,
            ...item
          }
        })
        setRows(formattedData);
        setDataLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setDataLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 100));
    setPage(0);
  };

  const handleCountClick = async (operationTypeId) => {
    setDataLoading(true);
    try {
      const response = await getLiveInnerReports(operationTypeId);
      const responseData = response.data;
      const formattedData = responseData.map((item, index) => {
        return {
          sNo: index + 1,
          ...item
        }
      })
      navigate("/live-inner-reports", { state: formattedData });
      setDataLoading(false);
    } catch (error) {
      console.error("Error fetching vehicle wise report:", error);
      setDataLoading(false);
    }
  };


  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const dataToUse = rows;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Traffic Marshal Live Report Generated on: ${formattedDate}, ${formattedTime}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Drivers");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to merged cells
    for (let col = 2; col <= 6; col++) {
        worksheet.getCell(1, col).font = boldFont;
        worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Live Report" header
    worksheet.addRow(["", "", "Live Report", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Live Report";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to merged cells
    for (let col = 2; col <= 6; col++) {
        worksheet.getCell(2, col).font = boldFont;
        worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add an empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow(["S.No", "Operation Type", "Count"]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = boldFont;
        cell.alignment = { horizontal: "left" };
        if (colNumber >= 1 && colNumber <= 3) {
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "F6B1B1" }, // Light red background
                bgColor: { argb: "FFFFFFFF" }, // White text
            };
        }
    });

    // Add data rows
    let totalCount = 0; // Variable to store the sum of counts
    dataToUse.forEach((item, index) => {
        totalCount += item.count; // Sum the counts

        worksheet
            .addRow([index + 1, item.operationTypeName?? "N/A", item.count?? "N/A"])
            .eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (colNumber >= 1 && colNumber <= 3) {
                    cell.alignment = { horizontal: "left" };
                } else {
                    cell.alignment = { horizontal: "center" };
                }
            });
    });

    // **Add Total Row**
    const totalRow = worksheet.addRow(["", "Total", totalCount]);
    totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        cell.font = { bold: true, color: { argb: "black" } }; // Bold and red text
        cell.alignment = { horizontal: colNumber === 1 ? "left" : "left" };
    });

    // Set column widths
    worksheet.columns = [
        { width: 5 },    // S.No
        { width: 30 },   // Operation Type
        { width: 20 },   // Count
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "TrafficMarshalLiveReport.xlsx";
    a.click();
    URL.revokeObjectURL(url);
};



  const headerStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', color: '#fff', backgroundColor: isProd ? "#0d5da5" : "#EC1117", }
  const cellStyles = { textAlign: 'center', border: '1px solid #ddd', borderRight: 'none', padding: '10px', whiteSpace: "normal" };

  return (
    <div className="content">
      <div className="page-content">
        <h4 class="text-start mb-3">Live Report</h4>
        <div className="card">
          <div className="card-body p-3">
            <div>
              <button
                className="btn btn-excel ms-auto"
                onClick={downloadAsExcel}
              >
                <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
              </button>
            </div>
            <div className='table-responsive'>
              {dataLoading ? <TableSkeleton /> : <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '20px' }}>
                <TableContainer
                  component={Paper}
                  sx={{
                    width: '100%',
                    maxHeight: '500px',
                    border: '1px solid #ccc',
                  }}
                >
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead
                      sx={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 0, // Ensure header stays above other content
                      }}
                    >
                      <TableRow sx={{ paddingTop: '20px' }}>
                        <TableCell sx={headerStyles}>S.No</TableCell>
                        <TableCell sx={headerStyles}>Operation Type</TableCell>
                        <TableCell sx={headerStyles}>Count</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length > 0 ? (
                        rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                backgroundColor: isProd
                                  ? index % 2 === 0
                                    ? '#8fc9ff'
                                    : '#aed8ff'
                                  : index % 2 === 0
                                    ? '#F8CCCD'
                                    : '#ffeded',
                                '&:nth-of-type(odd)': { backgroundColor: isProd ? '#aed8ff' : '#ffeded' },
                                '&:nth-of-type(even)': { backgroundColor: isProd ? '#8fc9ff' : '#F8CCCD' },
                              }}
                            >
                              <TableCell sx={cellStyles}>{row.sNo}</TableCell>
                              <TableCell sx={cellStyles}>{row.operationTypeName ?? 'N/A'}</TableCell>
                              <TableCell style={{ color: "blue", cursor: "pointer" }} onClick={() => handleCountClick(row.operationTypeId)} sx={cellStyles}>{row.count ?? 'N/A'}</TableCell>
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={20} sx={{ textAlign: 'center' }}>No data available</TableCell>
                        </TableRow>
                      )}
                      
                    </TableBody>
                    <TableFooter>
                          <TableRow sx={{ backgroundColor: 'rgb(255, 237, 238)', fontWeight: 'bold' }}>
                          <TableCell sx={{ textAlign: 'center', color:'black' }} ></TableCell>
                            <TableCell sx={{ textAlign: 'center', color:'black',fontSize:'15px' }} >Total</TableCell>
                            <TableCell sx={{textAlign: 'center', border: '1px solid #ddd',color:'black',fontSize:'15px'}}>{rows.reduce((sum, row) => sum + (row.count ?? 0), 0)}</TableCell>
                          </TableRow>
                        </TableFooter>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={rows.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveReports;
